mutation DeleteImpactMeasurementCategory($id: ID!) {
  deleteImpactMeasurementCategory(input: { id: $id }) {
    success
  }
}
